module.exports = __webpack_public_path__ + "media/footer/phone-c93c0db4.svg";